import { supabase } from "../utils/supabase";

export async function getPosts_Filtered(start: number, maxLimit: number, sort: string) {
    try {
        const { data, error } = await supabase
            .rpc('get_all_data_sorted', {
                start_point: start,
                end_point: maxLimit,
                sort_order: sort
            });

        if(error) {
            throw new Error(error.message);
        }
        else if(data !== null){
            return data;
        }
    }
    catch(e) {
        console.error("Get All Data error" + e);
        return [];
    }
}